import React, { Component } from "react";
import ListingPage from "../2/Controls/ListingPage";
import AddEditProductCategory from "./AddEditProductCategory";
import * as actionTypes from "../../actionTypes";
import Input from "../2/Controls/Input";
import Window from "../2/Controls/Window";
import ExportButton from "../2/Controls/ExportButton";
import { exportFile } from "../../actions/DataExporter";

class SubCategoryList extends Component {

  constructor(props) {
    super(props);

    this.state = {
      list: [],
      totalCount: 0,
      loading: false,

      page: 1,
      pageSize: 25,

      filter: {
        name: "",
        status: "active",
        parentId: ""
      },

      showAddCategory: false,
      selectedRow: null,

      showFilter: false,
      showOption: false,
      showDelete: false,

      isFilterActive: false,

      showExportMessage: false,
      exportMessage: ""
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {

    this.setState({ loading: true });

    const { page, pageSize, filter } = this.state;

    const from = (page - 1) * pageSize;

    try {

      const res = await this.props.getProductSubCategories(
        from,
        pageSize,
        filter.name,
        filter.status,
        "",
        filter.parentId
      );

      this.setState({
        list: res.searchResult || [],
        totalCount: res.totalCount || 0,
        loading: false
      });

    } catch (err) {

      console.error(err);

      this.setState({
        loading: false
      });

    }

  };

  /* -------------------------
     SEARCH
  -------------------------- */

  onSearch = (searchText) => {

    this.setState({

      filter: {
        ...this.state.filter,
        name: searchText
      },

      page: 1

    }, this.loadData);

  };


  /* -------------------------
     PAGINATION
  -------------------------- */

  onNextClick = () => {

    const totalPages =
      Math.ceil(
        this.state.totalCount /
        this.state.pageSize
      );

    if (this.state.page < totalPages) {

      this.setState(
        prev => ({
          page: prev.page + 1
        }),
        this.loadData
      );

    }

  };


  onPreviousClick = () => {

    if (this.state.page > 1) {

      this.setState(
        prev => ({
          page: prev.page - 1
        }),
        this.loadData
      );

    }

  };


  onFirstClick = () => {

    this.setState({
      page: 1
    }, this.loadData);

  };


  onLastClick = () => {

    const totalPages =
      Math.ceil(
        this.state.totalCount /
        this.state.pageSize
      );

    this.setState({
      page: totalPages
    }, this.loadData);

  };


  onRecordsPerPageCountChange = (pageSize) => {

    this.setState({

      pageSize: Number(pageSize),
      page: 1

    }, this.loadData);

  };


  /* -------------------------
     HEADER BUTTON
  -------------------------- */

  onHeaderButtonClicked = (btn) => {

    if (btn.Action === "popup") {

      this.setState({

        showAddCategory: true,
        selectedRow: null

      });

    }

    if (btn.Action === "options") {

      this.setState({
        showOption: true
      });

    }

  };


  /* -------------------------
     FILTER
  -------------------------- */

  onApplyFilter = () => {

    this.setState({

      isFilterActive: true,
      page: 1,
      showFilter: false

    }, this.loadData);

  };


  onClearFilter = () => {

    this.setState({

      filter: {
        name: "",
        status: "active",
        parentId: ""
      },

      isFilterActive: false,
      page: 1,
      showFilter: false

    }, this.loadData);

  };


  /* -------------------------
     ROW BUTTON
  -------------------------- */

  onRowButtonClicked = (btn, row) => {

    if (btn.Action === "popup") {

      this.setState({

        showAddCategory: true,
        selectedRow: row

      });

    }

    if (btn.Action === "delete") {

      this.setState({

        showDelete: true,
        selectedRow: row

      });

    }

  };


  deleteRecord = () => {

    this.props
      .deleteProductCategory(
        this.state.selectedRow.key
      )
      .then(() => {

        this.setState({

          showDelete: false,
          selectedRow: null

        }, this.loadData);

      });

  };


  /* -------------------------
     EXPORT
  -------------------------- */

  handleExport = async (type) => {

    const exportColumns = [

      {
        header: "Sub Category",
        field: "Name"
      },

      {
        header: "Category",
        field: "Parent"
      },

      {
        header: "Sequence",
        field: "Sequence"
      },

      {
        header: "Online",
        field: "OMNIEnabled",
        type: "boolean"
      }

    ];

    try {

      const res =
        await this.props.getProductSubCategories(
          0,
          10000,
          this.state.filter.name,
          this.state.filter.status,
          "",
          this.state.filter.parentId
        );

      let data =
        res.searchResult || [];

      if (data.length > 0) {

        await exportFile({

          data,
          columns: exportColumns,
          fileType: type,
          title: "Sub Category",
          landscape: true

        });

      }

      else {

        this.setState({

          showExportMessage: true,
          exportMessage: "No data available to export"

        });

      }

    }

    catch (error) {

      console.error(error);

      this.setState({

        showExportMessage: true,
        exportMessage: "Export failed"

      });

    }

  };


  /* -------------------------
     LIST CONFIG
  -------------------------- */

  getListSettings = () => ({

    Title: "Sub Category",

    Search: {

      showSearch: true,

      placeholder:
        "Search by sub category name",

      onSearch: this.onSearch,

      onFilterClick: () =>
        this.setState({
          showFilter: true
        }),

      isFilterActive:
        this.state.isFilterActive,

     onRefresh: this.onRefreshClick

    },

    HeaderButtons: [

      {
        ButtonType: "Button",
        Type: "primary",
        Text: "New",
        Icon: "add",
        Action: "popup"
      },

      {
        ButtonType: "ImageButton",
        Type: "option",
        Text: "Options",
        Icon: "option",
        Action: "options"
      }

    ],

    Columns: [

      {
        Name: "Name",
        Type: "field",
        ShowInMobile: true,
        Columns: [
          { Column: "Name" },
          { Column: "Parent", Label: "Category" },
          { Column: "Sequence", Label: "Sequence" }
        ]
      },

      {
        Name: "Name",
        Type: "field",
        Columns: [
          { Column: "Name" }
        ]
      },

      {
        Name: "Category",
        Type: "field",
        Columns: [
          { Column: "Parent" }
        ]
      },

      {
        Name: "Sequence",
        Type: "field",
        Columns: [
          { Column: "Sequence" }
        ]
      },

      {
        Name: "Color",
        Type: "field",
        Columns: [
          {
            Column: "Color",
            Type: "color"
          }
        ]
      },

      {
        Name: "Image",
        Type: "field",
        Columns: [
          {
            Column: "Image.Preview",
            Type: "image"
          }
        ]
      },

      {
        Name: "Online",
        Type: "field",
        Columns: [
          {
            Column: "OMNIEnabled",
            Type: "yesno"
          }
        ]
      }

    ],

    RowButtons: [

      {
        ButtonType: "ImageButton",
        Type: "edit",
        Text: "Edit",
        Icon: "edit",
        Action: "popup"
      },

      {
        ButtonType: "ImageButton",
        Type: "delete",
        Text: "Delete",
        Icon: "delete",
        Action: "delete"
      }

    ]

  });


  /* -------------------------
     RENDER
  -------------------------- */
  onRefreshClick = () => {

  this.setState({

    filter: {
      name: "",
      status: "active",
      parentId: ""
    },

    isFilterActive: false,
    page: 1

  }, this.loadData);

};

onPageChange = (page, pageSize) => {
  console.log("page",page);
  this.setState(
    { page, pageSize },
    () => {
      this.loadData();
    }
  );
};

  render() {

    return (

      <>

        <ListingPage
           {...this.props} 
          listPageSettings={
            this.getListSettings()
          }

           onPageChange={this.onPageChange}

          list={
            this.state.list
          }

          loading={
            this.state.loading
          }

          totalItemsCount={
            this.state.totalCount
          }

          recordFrom={
            (this.state.page - 1) *
            this.state.pageSize
          }

          itemsCountPerPage={
            this.state.pageSize
          }

          onNextClick={
            this.onNextClick
          }

          onPreviousClick={
            this.onPreviousClick
          }

          onFirstClick={
            this.onFirstClick
          }

          onLastClick={
            this.onLastClick
          }

          onRecordsPerPageCountChange={
            this.onRecordsPerPageCountChange
          }

          onHeaderButtonClicked={
            this.onHeaderButtonClicked
          }

          onRowButtonClicked={
            this.onRowButtonClicked
          }

        />


        {/* ADD EDIT */}

        {
          this.state.showAddCategory &&

          <AddEditProductCategory

            {...this.props}

            productCategory={
              this.state.selectedRow
            }

            type={
              actionTypes.PRODUCT_SUB_CATEGORY
            }

            onSave={() =>
              this.setState(
                {
                  showAddCategory: false
                },
                this.loadData
              )
            }

            onClose={() =>
              this.setState({
                showAddCategory: false
              })
            }

          />

        }


        {/* FILTER */}

        {
          this.state.showFilter &&

          <Window

            header="Filter"

            size="small"

            slide={true}

            onClose={() =>
              this.setState({
                showFilter: false
              })
            }

            onButtonClick={(action) => {

              if (action === "Apply")
                this.onApplyFilter();

              if (action === "Clear")
                this.onClearFilter();

            }}

            buttons={[

              {
                Type: "secondary",
                Text: "Clear",
                Align: "left"
              },

              {
                Type: "primary",
                Text: "Apply",
                Align: "right"
              }

            ]}

          >

            <Input

              type="text"

              label="Name"

              value={
                this.state.filter.name
              }

              onChange={(value) =>
                this.setState({

                  filter: {
                    ...this.state.filter,
                    name: value
                  }

                })
              }

            />


            <Input

              type="select"

              label="Category"

              value={
                this.state.filter.parentId
              }

              onChange={(value) =>
                this.setState({

                  filter: {
                    ...this.state.filter,
                    parentId: value
                  }

                })
              }

            >

              <option value="">
                Select Category
              </option>

              {
                this.props.config.ProductCategories
                  .filter(
                    f => !f.IsDeleted
                  )
                  .map(cat => (

                    <option
                      key={cat.key}
                      value={cat.key}
                    >
                      {cat.Name}
                    </option>

                  ))
              }

            </Input>


            <Input

              type="select"

              label="Status"

              value={
                this.state.filter.status
              }

              onChange={(value) =>
                this.setState({

                  filter: {
                    ...this.state.filter,
                    status: value
                  }

                })
              }

            >

              <option value="active">
                Active
              </option>

              <option value="inActive">
                In Active
              </option>

              <option value="all">
                All
              </option>

            </Input>

          </Window>

        }


        {/* OPTIONS */}

        {
          this.state.showOption &&

          <Window

            header="Options" choiceList

            size="small"

            slide={true}

            onClose={() =>
              this.setState({
                showOption: false
              })
            }

          >

            <ExportButton

              onExport={
                this.handleExport
              }

              loading={
                this.state.loading
              }

            />

          </Window>

        }


        {/* DELETE */}

        {
          this.state.showDelete &&

          <Window

            header="Delete"

            modal={true}

            onClose={() =>
              this.setState({
                showDelete: false
              })
            }

            onButtonClick={(type) => {

              if (type === "Yes")
                this.deleteRecord();

              else

                this.setState({

                  showDelete: false,
                  selectedRow: null

                });

            }}

            buttons={[

              {
                Type: "secondary",
                Text: "No",
                Align: "left"
              },

              {
                Type: "primary",
                Text: "Yes",
                Align: "right"
              }

            ]}

          >

            Are you sure you want to delete?

          </Window>

        }


        {/* EXPORT MESSAGE */}

        {
          this.state.showExportMessage &&

          <Window

            header="Export"

            modal={true}

            onClose={() =>
              this.setState({

                showExportMessage: false

              })
            }

            buttons={[

              {
                Type: "primary",
                Text: "OK",
                Align: "right"
              }

            ]}

          >

            {
              this.state.exportMessage
            }

          </Window>

        }

      </>

    );

  }

}

export default SubCategoryList;